export const RoleConstants = {
    admin: 'Admin',
    applicationEngineer: 'Application Engineer',
    accountManager: 'Account Manager',
    user: 'User',
    aiApplicationEngineer: 'AI Application Engineer',
}

export const ProjectStatus = {
    inProgress: 0,
    acknowldged: 1,
    needReview: 2,
    reviewInProgress: 3,
    customerReady: 4,
    archived: 5,
}

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000"